import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Input @value={{this.value}} class=\"fly-form-control\" placeholder={{this.placeholder}} aria-label=\"Dropdown\" {{on \"keydown\" this.onKeyDownAction}} />", {
  moduleName: "@customerio/fly-components/templates/components/fly-dropdown-search-input.hbs"
});